var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.discount[_vm.price.baseRateKey]
    ? _c("div", { staticClass: "v-application" }, [
        _c(
          "span",
          { staticClass: "mr-2 font-weight-medium", class: _vm.labelColors },
          [_vm._v("\n        " + _vm._s(_vm.price.label) + ":\n    ")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "d-flex font-weight-bold" }, [
          _c("span", [_vm._v(_vm._s(_vm.discount[_vm.price.baseRateKey]))]),
          _vm._v(" "),
          _c("span", { staticClass: "mx-1" }, [_vm._v("/")]),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.discount[_vm.price.marginKey] || "-")),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }